export const integrationConstants = {
  GET_AVAIL_ORG_CONN_REQUEST: 'INTEGRATION/GET_AVAIL_ORG_CONN_REQUEST',
  GET_AVAIL_ORG_CONN_SUCCESS: 'INTEGRATION/GET_AVAIL_ORG_CONN_SUCCESS',
  GET_AVAIL_ORG_CONN_FAILURE: 'INTEGRATION/GET_AVAIL_ORG_CONN_FAILURE',

  GET_EXTERNAL_API_CONNECTION_REQUEST: 'INTEGRATION/GET_EXTERNAL_API_CONNECTION_REQUEST',
  GET_EXTERNAL_API_CONNECTION_SUCCESS: 'INTEGRATION/GET_EXTERNAL_API_CONNECTION_SUCCESS',
  GET_EXTERNAL_API_CONNECTION_FAILURE: 'INTEGRATION/GET_EXTERNAL_API_CONNECTION_FAILURE',

  SAVE_EXTERNAL_API_TOKEN_REQUEST: 'INTEGRATION/SAVE_EXTERNAL_API_TOKEN_REQUEST',
  SAVE_EXTERNAL_API_TOKEN_SUCCESS: 'INTEGRATION/SAVE_EXTERNAL_API_TOKEN_SUCCESS',
  SAVE_EXTERNAL_API_TOKEN_FAILURE: 'INTEGRATION/SAVE_EXTERNAL_API_TOKEN_FAILURE',

  SET_DEFAULT_ADD_TO_CALENDAR_REQUEST: 'INTEGRATION/SET_DEFAULT_ADD_TO_CALENDAR_REQUEST',
  SET_DEFAULT_ADD_TO_CALENDAR_SUCCESS: 'INTEGRATION/SET_DEFAULT_ADD_TO_CALENDAR_SUCCESS',
  SET_DEFAULT_ADD_TO_CALENDAR_FAILURE: 'INTEGRATION/SET_DEFAULT_ADD_TO_CALENDAR_FAILURE',

  SET_DEFAULT_VIRTUAL_MEET_REQUEST: 'INTEGRATION/SET_DEFAULT_VIRTUAL_MEET_REQUEST',
  SET_DEFAULT_VIRTUAL_MEET_SUCCESS: 'INTEGRATION/SET_DEFAULT_VIRTUAL_MEET_SUCCESS',
  SET_DEFAULT_VIRTUAL_MEET_FAILURE: 'INTEGRATION/SET_DEFAULT_VIRTUAL_MEET_FAILURE',

  GET_ACTIVE_DEFAULT_CONNS_REQUEST: 'INTEGRATION/GET_ACTIVE_DEFAULT_CONNS_REQUEST',
  GET_ACTIVE_DEFAULT_CONNS_SUCCESS: 'INTEGRATION/GET_ACTIVE_DEFAULT_CONNS_SUCCESS',
  GET_ACTIVE_DEFAULT_CONNS_FAILURE: 'INTEGRATION/GET_ACTIVE_DEFAULT_CONNS_FAILURE',

  GET_ALL_ACTIVE_CONNS_REQUEST: 'INTEGRATION/GET_ALL_ACTIVE_CONNS_REQUEST',
  GET_ALL_ACTIVE_CONNS_SUCCESS: 'INTEGRATION/GET_ALL_ACTIVE_CONNS_SUCCESS',
  GET_ALL_ACTIVE_CONNS_FAILURE: 'INTEGRATION/GET_ALL_ACTIVE_CONNS_FAILURE',

  REVOKE_TOKEN_REQUEST: 'INTEGRATION/REVOKE_TOKEN_REQUEST',
  REVOKE_TOKEN_SUCCESS: 'INTEGRATION/REVOKE_TOKEN_SUCCESS',
  REVOKE_TOKEN_FAILURE: 'INTEGRATION/REVOKE_TOKEN_FAILURE',

  POST_EVENT_TO_CAL_REQUEST: 'INTEGRATION/POST_EVENT_TO_CAL_REQUEST',
  POST_EVENT_TO_CAL_SUCCESS: 'INTEGRATION/POST_EVENT_TO_CAL_SUCCESS',
  POST_EVENT_TO_CAL_FAILURE: 'INTEGRATION/POST_EVENT_TO_CAL_FAILURE',

  ADD_TO_CALENDER_REQUEST: 'INTEGRATION/ADD_TO_CALENDER_REQUEST',
  ADD_TO_CALENDER_SUCCESS: 'INTEGRATION/ADD_TO_CALENDER_SUCCESS',
  ADD_TO_CALENDER_FAILURE: 'INTEGRATION/ADD_TO_CALENDER_FAILURE',

  OPEN_MODAL: 'INTEGRATION/OPEN_MODAL',
  CLOSE_MODAL: 'INTEGRATION/CLOSE_MODAL',

  CLEAR_DATA: 'INTEGRATION/CLEAR_DATA',

  UPDATE_INTEGRATION_REQUEST: 'INTEGRATION/UPDATE_INTEGRATION_REQUEST',
  UPDATE_INTEGRATION_SUCCESS: 'INTEGRATION/UPDATE_INTEGRATION_SUCCESS',
  UPDATE_INTEGRATION_FAILURE: 'INTEGRATION/UPDATE_INTEGRATION_FAILURE'
}
